import styled, { css } from "styled-components";
import { COLORS, fontMixins } from "../../../styles";

export const PlansContainer = styled.div`
	display: flex;
	column-gap: 8px;
`;

interface PlansItemProps {
	$isActive: boolean;
}

export const PlansItem = styled.div<PlansItemProps>`
	display: flex;
	${fontMixins(16, 400)};
	color: #989898;
	border-width: 1px 1px 0 1px;
	border-style: solid;
	border-color: #989898;
	padding: 10px 15px 10px;
	border-radius: 10px 10px 0 0;
	cursor: pointer;

	${(props) =>
		props.$isActive &&
		css`
			background: ${COLORS.White};
		`}
`;
